import theme from './themeImport'

const spaces = {
    sm_40px: theme.space.stack.sm,
}

export default spaces
